import { render, staticRenderFns } from "./SubtaskAddOrEdit.vue?vue&type=template&id=871c2754&scoped=true&"
import script from "./SubtaskAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./SubtaskAddOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871c2754",
  null
  
)

export default component.exports